import { NgModule } from '@angular/core';

import { SharedModule } from '../../../../../shared';
import { NgxBootstrapMultiselectModule } from 'ngx-bootstrap-multiselect';

import { CampanhaMultiselectComponent } from './campanha-multiselect.component';

@NgModule({
    imports: [
        SharedModule,
        NgxBootstrapMultiselectModule
    ],
    declarations: [
        CampanhaMultiselectComponent
    ],
    exports: [
        CampanhaMultiselectComponent
    ]
})
export class CampanhaMultiselectModule { }
